export const galleryItems = [
  {
    id: 1,
    category: "Bifold Doors",
    title: "Contemporary Garden Bifold",
    location: "Caterham, Surrey",
    image: "https://public.readdy.ai/ai/img_res/1863fffcdff9794947e1b7fedf009c7d.jpg",
  },
  {
    id: 2,
    category: "Windows",
    title: "Victorian Terrace uPVC Windows",
    location: "Redhill, Surrey",
    image: "https://readdy.ai/api/search-image?query=white%20uPVC%20sash%20windows%20victorian%20terrace%20house%20uk%20residential%20exterior%20classic%20elegant%20period%20property%20renovation&width=600&height=450&seq=gal2&orientation=landscape",
  },
  {
    id: 3,
    category: "Composite Doors",
    title: "Anthracite Composite Entrance",
    location: "Oxted, Surrey",
    image: "https://readdy.ai/api/search-image?query=dark%20anthracite%20grey%20composite%20front%20door%20modern%20uk%20home%20entrance%20stylish%20premium%20quality%20side%20glass%20panels%20elegant%20residential&width=600&height=450&seq=gal3&orientation=landscape",
  },
  {
    id: 4,
    category: "Conservatories",
    title: "Edwardian Conservatory Extension",
    location: "Warlingham, Surrey",
    image: "https://readdy.ai/api/search-image?query=white%20edwardian%20conservatory%20extension%20uk%20garden%20bright%20interior%20glass%20roof%20elegant%20traditional%20home%20plants%20natural%20light&width=600&height=450&seq=gal4&orientation=landscape",
  },
  {
    id: 5,
    category: "Roof Lanterns",
    title: "Kitchen Extension Roof Lantern",
    location: "Coulsdon, Surrey",
    image: "https://readdy.ai/api/search-image?query=aluminium%20roof%20lantern%20skylight%20kitchen%20extension%20modern%20uk%20home%20interior%20bright%20natural%20light%20contemporary%20living%20space%20architectural%20feature&width=600&height=450&seq=gal5&orientation=landscape",
  },
  {
    id: 6,
    category: "Bifold Doors",
    title: "Slim Frame Aluminium Bifolds",
    location: "Purley, South London",
    image: "https://readdy.ai/api/search-image?query=slim%20frame%20aluminium%20bifold%20doors%20closed%20exterior%20modern%20extension%20uk%20home%20grey%20anthracite%20architectural%20clean%20design&width=600&height=450&seq=gal6&orientation=landscape",
  },
  {
    id: 7,
    category: "Windows",
    title: "Flush Aluminium Windows",
    location: "Kenley, Surrey",
    image: "https://readdy.ai/api/search-image?query=flush%20casement%20aluminium%20windows%20modern%20uk%20home%20exterior%20large%20glass%20panels%20grey%20frames%20contemporary%20architecture&width=600&height=450&seq=gal7&orientation=landscape",
  },
  {
    id: 8,
    category: "Composite Doors",
    title: "Classic Cream Front Door",
    location: "Whyteleafe, Surrey",
    image: "https://readdy.ai/api/search-image?query=cream%20white%20composite%20front%20door%20traditional%20uk%20home%20entrance%20classic%20glass%20panels%20decorative%20elegant%20residential%20property&width=600&height=450&seq=gal8&orientation=landscape",
  },
  {
    id: 9,
    category: "Conservatories",
    title: "Lean-To Garden Room",
    location: "Caterham, Surrey",
    image: "https://readdy.ai/api/search-image?query=modern%20lean%20to%20conservatory%20garden%20room%20uk%20home%20extension%20glass%20roof%20white%20frames%20contemporary%20bright%20interior%20plants&width=600&height=450&seq=gal9&orientation=landscape",
  },
  {
    id: 10,
    category: "Bifold Doors",
    title: "Three-Panel Bifold Installation",
    location: "Reigate, Surrey",
    image: "https://readdy.ai/api/search-image?query=three%20panel%20bifold%20doors%20uk%20home%20garden%20view%20open%20aluminium%20white%20modern%20interior%20natural%20light%20patio%20lifestyle&width=600&height=450&seq=gal10&orientation=landscape",
  },
  {
    id: 11,
    category: "Windows",
    title: "Bay Window Renovation",
    location: "South Croydon",
    image: "https://readdy.ai/api/search-image?query=bay%20window%20uPVC%20renovation%20uk%20residential%20property%20exterior%20white%20clean%20traditional%20style%20elegant%20curb%20appeal&width=600&height=450&seq=gal11&orientation=landscape",
  },
  {
    id: 12,
    category: "Roof Lanterns",
    title: "Orangery Roof Lantern Feature",
    location: "Banstead, Surrey",
    image: "https://readdy.ai/api/search-image?query=large%20roof%20lantern%20orangery%20extension%20uk%20home%20interior%20flooded%20natural%20light%20elegant%20modern%20living%20space%20aluminium%20glass&width=600&height=450&seq=gal12&orientation=landscape",
  },
];

export const galleryCategories = ["All", "Bifold Doors", "Windows", "Composite Doors", "Conservatories", "Roof Lanterns"];
